import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { of } from "rxjs";
import { ISearchVirkesleverantor } from "./models/virkesleverantorModel";
import { VirkesleverantorService } from "./services/virkesleverantor.service";

export const VirkesleverantorResolver: ResolveFn<ISearchVirkesleverantor[]> = (route, _state) => {
    const leverantorService = inject(VirkesleverantorService);
    const leverantorId = route.paramMap.get("id");

    if(!leverantorId) {
        return of(null);
    }

    return leverantorService.searchForVirkeskopsleverantor({ leverantorId: Number(leverantorId) });
};
